// 共通js

import "../sass/common.scss"; // 共通css

import htmx from "htmx.org";

import { setClickHandle } from "../jsmodules/toggleClassName";
import { SmoothScroll } from "../jsmodules/smoothScroll";
import { Modal } from "../jsmodules/modal";
import { initCarousels } from "../jsmodules/carousel";
import { initReveal } from "../jsmodules/reveal";

// スムーズスクロールのインスタンス
const ss = new SmoothScroll();
ss.watch();

/**
 * 後から差し込まれる要素にも効かせたい初期化。
 * ページ内に元からある分と、htmxが読み込んだ分の両方で呼ぶ。
 * どちらも二重に初期化しないようになっている。
 */
const initDeferred = () => {
	initCarousels();
	initReveal();
};

// htmxの読み込みが全て終わってから実行する
const HTMX_ELM_COUNT = htmx.findAll(`[hx-trigger="load"]`).length;
if (HTMX_ELM_COUNT > 0) {
	let LOADED_COUNT = 0;

	htmx.on("htmx:afterSettle", () => {
		LOADED_COUNT += 1;
		if (HTMX_ELM_COUNT !== LOADED_COUNT) return;

		setClickHandle(".js-menu-trigger", "body", "opened-menu");
		initDeferred();

		// DOMの描画が完結するまで遅延せざるを得ない
		setTimeout(() => {
			ss.addClassNameAllowsJump();
		}, 100);
	});
}

document.addEventListener("DOMContentLoaded", () => {
	const modal = new Modal();
	modal.init();

	ss.setJumpInpage();
	initDeferred();
});
